import { Octokit } from "@octokit/core"
import { createAppAuth } from "@octokit/auth-app"
import PipelineConfig from "app/pipelineConfig"

const appId = process.env.GITHUB_APP_ID!
const installationUrl = process.env.GITHUB_APP_INSTALLATION_URL!
const privateKey64 = process.env.GITHUB_APP_PRIVATE_KEY64!

export async function getInstallationOctokit(owner?: string) {
  const privateKey = Buffer.from(privateKey64, "base64")

  if (!owner) throw new Error(`Missing GitHub owner`)

  const appOctokit = new Octokit({
    authStrategy: createAppAuth,
    auth: {
      appId,
      privateKey,
    },
  })

  const installations = await appOctokit.request("GET /app/installations")
  console.log({ installations: JSON.stringify(installations) })

  const installation = installations.data.find((inst) => inst.account?.login === owner)
  if (!installation) throw new Error(`Install app ${installationUrl}`)

  const installationId = installation.id
  console.log({ installationId })

  const installationOctokit = new Octokit({
    authStrategy: createAppAuth,
    auth: {
      appId,
      privateKey,
      installationId: installation.id,
    },
  })

  return installationOctokit
}

export function getPipelineConfig(
  githubRepositoryUrl: string,
  githubRepositoryRef: string,
  githubRepositoryPath: string
): Promise<PipelineConfig | undefined> {
  return getContent(githubRepositoryUrl, githubRepositoryRef, githubRepositoryPath, "pipeline.json")
}

export async function getContent(
  githubRepositoryUrl: string,
  githubRepositoryRef: string,
  githubRepositoryPath: string,
  filename: string
): Promise<any | undefined> {
  const url = new URL(githubRepositoryUrl!)
  const ownerAndRepo = url.pathname.replace(/^[\/]+/, "").replace(/[\/]+$/, "")
  const [owner, repo] = ownerAndRepo.split("/")

  const path = [normalizeGithubRepositoryPath(githubRepositoryPath), filename]
    .filter(Boolean)
    .join("/")

  const octokit = await getInstallationOctokit(owner)
  const response = await octokit.request(`GET /repos/${owner}/${repo}/contents/${path}`, {
    owner,
    repo,
    path,
    ref: githubRepositoryRef,
  })

  if (response.status === 200) {
    const encodedContent = response.data.content
    const buff = Buffer.from(encodedContent, "base64")
    const content = buff.toString("utf8")
    return JSON.parse(content)
  }

  return undefined
}

export function normalizeGithubRepositoryPath(githubRepositoryPath: string): string {
  if (githubRepositoryPath.length && !githubRepositoryPath.includes("src/")) {
    githubRepositoryPath = "src/" + githubRepositoryPath
  }
  githubRepositoryPath.replace(/^[\/]+/, "").replace(/[\/]+$/, "")

  return githubRepositoryPath
}
